

const CRMMapEmbed = require('./embed/CRMMapEmbed');

const style = require('./embed/embed.scss');

document.currentScript = document.currentScript || (function() {
  var scripts = document.getElementsByTagName('script');
  return scripts[scripts.length - 1];
})();	  


var cs = document.currentScript;
var idtag = cs.getAttribute('idtag') || "map";
var apihost =  cs.getAttribute('apihost') || cs.src.replace(/dist\/embed.js.*/,'') + 'api.php';
console.log('apihost',apihost);
var googleapikey = cs.getAttribute('googleapikey');
var crmmapapikey = cs.getAttribute('crmmapapikey');

console.log('googleapikey', googleapikey);
console.log('crmmapapikey', crmmapapikey);

CRMMap= new CRMMapEmbed(apihost, crmmapapikey , idtag);

//Load Google JS API, And call CRMMapInit
var script = document.createElement('script');
script.src = "https://maps.googleapis.com/maps/api/js?v="+GOOGLEVERSION+"&callback=CRMMap.init&libraries=places,visualization,drawing&key=" + googleapikey;
document.head.appendChild(script);


